import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG } from '@libs/configs';

@Injectable({
  providedIn: 'root',
})
export class MediaApiService {
  private mediaUrl: string;

  constructor(@Inject(APP_CONFIG) private appConfig: any) {
    if (appConfig.domain === 'snagprod.corp') {
      this.mediaUrl = 'https://media.api.snagajob.com/';
    } else if (appConfig.domain) {
      const proxyDomain = appConfig.domain.replace('.corp', '.com');
      this.mediaUrl = `https://media-api-proxy.${proxyDomain}/`;
    }
  }

  getMediaUrl(logoMediaId: string, width: number, height: number): string {
    const parameters: string[] = [];

    if (width) {
      parameters.push('width=' + width);
    }
    if (height) {
      parameters.push('height=' + height);
    }

    return parameters.length > 0
      ? this.mediaUrl + logoMediaId + '?' + parameters.join('&')
      : this.mediaUrl + logoMediaId;
  }
}
